import { ISimilarityMatch } from 'APIPackage/SimilarityModule/interfaces/ISimilarityMatch';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { SimilaritiesByPersonErpIdCell } from '../components/SimilaritiesByPersonErpIdCell';
import { SimilaritiesByPersonPlanIdCell } from '../components/SimilaritiesByPersonPlanIdCell';

export const similaritiesByPersonTableHeaders: ITableColumn<ISimilarityMatch>[] = [
  {
    name: 'НОМЕР ПЛАНА',
    id: 'planId',
    isDisabledSort: true,
    renderCell: SimilaritiesByPersonPlanIdCell,
  },
  {
    name: 'НОМЕР КНМ',
    id: 'erpId',
    isDisabledSort: true,
    renderCell: ({ row, isErknm }) => <SimilaritiesByPersonErpIdCell row={row} isErknm={isErknm} />,
  },
  {
    name: 'НАИМЕНОВАНИЕ КНО',
    id: 'knoFullName',
    isDisabledSort: true,
  },
  {
    name: 'НАИМЕНОВАНИЕ ПРОКУРАТУРЫ',
    id: 'prosecutorFullName',
    isDisabledSort: true,
  },
  {
    name: 'СТАТУС КНМ',
    id: 'matchStatus',
    dataColumnType: 'centre',
    isDisabledSort: true,
  },
  {
    name: 'ДАТА НАЧАЛА ПРОВЕДЕНИЯ КНМ',
    id: 'startDate',
    dataColumnType: 'centre',
    isDisabledSort: true,
    renderCell: ({ row }) => row.startDate.split('-').reverse().join('.'),
  },
  {
    name: 'ДЛИТЕЛЬНОСТЬ (В ДНЯХ)',
    id: 'durationDays',
    dataColumnType: 'centre',
    isDisabledSort: true,
  },
  {
    name: 'ДЛИТЕЛЬНОСТЬ (В ЧАСАХ)',
    id: 'durationHours',
    dataColumnType: 'centre',
    isDisabledSort: true,
  },
];
